module.exports = __webpack_public_path__ + "img/azure.4a307cf1.png";